import { render, staticRenderFns } from "./Pause3.vue?vue&type=template&id=638c24c1&"
import script from "./Pause3.vue?vue&type=script&lang=js&"
export * from "./Pause3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports